module.exports = __webpack_public_path__ + "img/take-away.b84b02be.png";